__turbopack_context__.v({
  "actionIcon": "OffersCarousel-module__Ie2mRq__actionIcon",
  "content": "OffersCarousel-module__Ie2mRq__content",
  "embla": "OffersCarousel-module__Ie2mRq__embla",
  "emblaContainer": "OffersCarousel-module__Ie2mRq__emblaContainer",
  "emblaSlide": "OffersCarousel-module__Ie2mRq__emblaSlide",
  "imageContainer": "OffersCarousel-module__Ie2mRq__imageContainer",
  "nextBtn": "OffersCarousel-module__Ie2mRq__nextBtn",
  "offerElement": "OffersCarousel-module__Ie2mRq__offerElement",
  "plus": "OffersCarousel-module__Ie2mRq__plus",
  "root": "OffersCarousel-module__Ie2mRq__root",
  "square": "OffersCarousel-module__Ie2mRq__square",
});
